import React, { createContext, useContext } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

// Create a Context object for Axios instance
const AxiosContext = createContext();

export const AxiosProvider = ({ children }) => {
  // Hooks for getting location and navigating programmatically
  const location = useLocation();
  const navigate = useNavigate();

  // Create an Axios instance
  const axiosInstance = axios.create();

  // Add a request interceptor to include the authorization token
  axiosInstance.interceptors.request.use(
    (config) => {
      // Get the token from location state or use an empty string if not available
      const token = location.state?.accessToken || "";
      config.headers.Authorization = `Bearer ${token}`;
      return config;
    },
    (error) => Promise.reject(error)
  );

  // Add a response interceptor to handle unauthorized access
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      // Check if the error status is 401 (Unauthorized)
      if (error.response && error.response.status === 401) {
        console.log("Unauthorized! Redirecting to login page...");
        // Clear the history state and navigate to the login page
        window.history.replaceState(null, null, null);
        navigate("/", { state: {} });
      }
      return Promise.reject(error);
    }
  );

  return (
    // Provide the configured Axios instance to the children components
    <AxiosContext.Provider value={axiosInstance}>
      {children}
    </AxiosContext.Provider>
  );
};

// Custom hook to use the Axios instance from the context
export const useAxios = () => useContext(AxiosContext);
